<template>
  <div>
    <div class="top-contrainer">
        <div class="layout-header" v-if="version != 'guangdianzhongda' && $route.name === 'mainSearch'">
          <div class="layout-header-system">
            <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo" @click="goStaticHome">
            <span class="layout-header-system-label">智能法规检索</span>
            <span class="layout-header-system-enterprise" v-if="isEnterprise">企业版</span>
          </div>
          <div class="layout-header-user-info">
            <div class="system-expired-info" v-if="!isEnterprise && !isThird">
              <template v-if="lawInfo">
                <div class="vip-time-info" v-if="lawInfo.dueTime && !lawIsExpired">
                  <div class="vip-time-info-content">
                    <img class="vip-time-info-img" src="../assets/vip@2x.png" alt="">
                    <span>{{ lawInfo.dueTime | time-filter }} 到期</span>
                  </div>
                  <div class="vip-time-info-renew-btn" @click="vipPaneShow = true">续费</div>
                </div>
                <div class="vip-free-surplus" v-else>
                  <el-tooltip effect="dark" content="试用次数可用于：普通检索、高级检索、结果中检索、法律法规明细（包括法条详情、新旧对照等）、法律法规下载" placement="bottom">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  <span>免费体验剩余次数：{{ lawFreeSurplus }}次</span>
                  <div class="vip-free-surplus-btn" @click="vipPaneShow = true">购买VIP</div>
                </div>
              </template>
            </div>
            <el-dropdown >
              <span class="el-dropdown-link" :style="{ cursor: 'pointer' }">
                <span class="icon-middle" style="width:30px;margin-right: 10px;">
                  <img :src="projectInfoConfig.isDefault ? defaultAvatar1 : defaultAvatar2" alt="">
                </span>
                {{userInfo.tel | phone-filter}}<i class="el-icon-arrow-down el-icon--right" v-if="!isThird"></i>
              </span>
              <el-dropdown-menu slot="dropdown" v-if="!isThird">
                <el-dropdown-item>
                  <div class="header-portrait">
                    <div class="icon-middle" style="width:30px;margin-left:-5px;margin-right: 10px;">
                      <img src="../assets/default-icon.png" alt="">
                    </div>
                    <div>
                      <p>{{userInfo.tel | phone-filter}}</p>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-if="!isThird">
                  <div class="user-dropdown">
                  <router-link :to="'/law/center'">个人中心</router-link>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item v-if="!projectInfoConfig.hideLogout">
                  <div @click="loginOut" class="user-dropdown">
                  <a>退出</a>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div v-else class="main-header" :class="this.$route.path == '/main/home'?'black-header':''" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)">
            <div class="left-header" v-if="version != 'guangdianzhongda'">
                <div class="layout-header-system">
                  <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo" @click="goStaticHome">
                </div>

                <!-- <layout-menu @login="showDialog('wechat', 'login')" :is-login="Object.keys(userInfo || {}).length > 0" /> -->
            </div>
            <div class="left-header" v-else>
              <div class="layout-header-system">
                <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo">
                <span class="layout-header-system-label">智能法规检索</span>
              </div>
            </div>
            <div class="right-header" v-if="version != 'guangdianzhongda'">
              <el-dropdown  v-if="userInfo.tel">
                <span class="el-dropdown-link">
                  <span class="icon-middle" style="width:30px;margin-right: 10px;">
                    <img src="../assets/default-icon.png" alt="">
                  </span>
                  {{userInfo.tel | phone-filter}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="header-portrait">
                      <div class="icon-middle" style="width:30px;margin-left:-5px;margin-right: 10px;">
                        <img :src="projectInfoConfig.isDefault ? defaultAvatar1 : defaultAvatar2" alt="">
                      </div>
                      <div>
                        <p>{{userInfo.tel | phone-filter}}</p>
                      </div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="!isThird">
                    <div class="user-dropdown">
                     <router-link :to="'/main/center'">个人中心</router-link>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="user-dropdown">
                      <a href="fanwen/questionnaire/center">法治体检报告</a>
                    </div>
                  </el-dropdown-item>
                   <el-dropdown-item v-if="!projectInfoConfig.hideLogout">
                    <div @click="loginOut" class="user-dropdown">
                     <a>退出</a>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else>
                <a @click="showDialog('wechat', 'login')">登录</a>
                <el-button @click="showDialog('wechat', 'register')" type="primary">注册</el-button>
              </div>  
            </div>
            <div class="right-header" v-else>
              <span class="el-dropdown-link" v-if="userInfo.id">
                
              </span>
              <div v-else>
                <a @click="loginGdStatus = true">登录</a>
              </div>  
            </div>
        </div>
     </div>
     <router-view ref="home"></router-view>

     <!-- 广电仲达登录 -->
    <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="loginGdStatus" title="手机号免密登录" @close="closeLocalLogin"   :close-on-click-modal="false">
       <div>
          <div class="form">
              <el-input v-model="model.tel" type="text" placeholder="手机号"></el-input>
          </div>
          <div class="form">
              <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
              <a class="send-number" @click="sendCode" :disabled="disabled">{{sendWord}}</a>
          </div>
          
          <div style="margin:40px 0 80px;">
              <div>
                <el-button style="width:100%;background:@mainColor" @click="verifiEvent" type="primary">立即登录</el-button> 
              </div>
          </div>
          <div class="form">
              <span>登录即代表同意<span style="color:#4A90E2;cursor:pointer" @click="agreement=true">《用户注册协议》</span>和<span style="color:#4A90E2;cursor:pointer" @click="privacy=true">《隐私政策》</span></span>
          </div>
       </div>
    </el-dialog>


     <el-dialog width="500px" custom-class="freeDialog" :visible.sync="freeTime" :show-close="false" :close-on-click-modal="false">
       <div class="code-panel">
         <h4>免费试用已结束</h4>
         <p class="if word-middle">如需继续使用系统，请购买许可证密钥。</p>
         <div class="code-bar">
           <p>如果你已经购买了许可证密钥，请输入 License Key</p>
           <el-input v-model="secretKey" type="text" placeholder="xxxx-xxxx-xxxx-xxxx"></el-input>
           <div style="text-align:right;margin-top:10px;">
             <el-button style="width:120px;" type="primary" @click="activationEvent">激活</el-button>
           </div>
         </div>
       </div>
     </el-dialog>


     <el-dialog width="700px" custom-class="buyVipDialog" :visible.sync="buyVip && productList.length>0" :show-close="true" :close-on-click-modal="true" @close="closeDialog">
       <div class="buy-panel">
          <div class="buy-panel-top">
            <div class="header-portrait">
              <div style="margin: 0 10px 10px 10px">
                <span style="width:32px;" class="icon-big"><img src="../assets/default-icon-64.png" alt=""></span>
              </div>
              <div class="tel">
                <p>{{userInfo.tel}}</p>
              </div>
            </div>
          </div>
          <div class="buy-panel-body">
            <div class="buy-panel-left">
              <ul>
                <li @click="choicePro(item)" :class="activeBuy==item.name?'cur':''" v-for="(item,index) in productList" :key="index">
                  <span class="vip-list-icon">
                    <img src="../assets/vip-list.png" alt="">
                    <img src="../assets/vip-list-gray.png" alt="">
                  </span>
                  <a>{{item.name}}</a>
                </li>
              </ul>
            </div>
            <div class="buy-panel-right">
              <h4>{{productModel.name}}VIP套餐</h4>
              <div style="display:flex">
                <div v-for="(col,idx) in productModel.subItem" :key="idx" class="sub-pro" @click="choiceWay(col,idx)" :class="activeWay == idx?'cur':''">
                  <p v-if="col.productList[0].chargeType == 'month'">{{col.productList[0].chargeCycle}}个月</p>
                  <p v-else>{{col.productList[0].chargeCycle}}次</p>
                  <span>¥{{col.discountPrince}}</span>
                  <s>原价{{col.firstPrince}}</s>
                </div>
              </div>

              <div class="vip-tip">
                <div v-if="productModel.descHtml" v-html="productModel.descHtml"></div>
                <template v-else>
                  <p>VIP特权</p>
                  <span class="word-normal">{{productModel.desc}}</span>
                </template>
              </div>

              <div class="pay-panel">
                <div id="qrcode" ref="qrcode"></div>
                <div style="margin-left:20px;">
                  <div style="color:#222;font-size:16px;margin-bottom:10px;">应付金额</div>
                    <div>
                      <span style="color:#E42626;font-size:28px;font-weight:bold">
                        ¥{{way.discountPrince}}
                      </span>
                      <s style="color:#999;" class="word-normal" v-if="way.firstPrince">
                        原价{{way.firstPrince}}元
                      </s>
                    </div>
                    <div style="margin-top:27px;">
                      <span class="wechat-pay"><img src="../assets/wechat-pay.png" alt=""></span>
                      <span>使用微信扫码支付</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
       </div>
     </el-dialog>

    <!-- 登录 -->
    <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="loginStatus" :title="titleWord" @close="closeLocalLogin" :close-on-click-modal="false">
       <div>
          <div class="form"> 
              <el-input v-if="!noPassword" v-model="model.tel" @blur="telInputBlur" type="text" placeholder="手机号/邮箱"></el-input>
              <el-input v-else v-model="model.tel" @blur="telInputBlur" type="text" placeholder="手机号"></el-input>
          </div>
          <div class="form">
              <el-input v-if="!noPassword && !forgetPsw" v-model="model.password" type="password" placeholder="密码"></el-input>
              <div v-else>
                <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
                 <a class="send-number" @click="sendCode" :disabled="disabled">{{sendWord}}</a>
              </div>
          </div>
          <div class="form">
            <div class="password">
                <span v-if="!usePsw && noPassword" @click="changeLoginWay('psw')">账号密码登录</span>
                <span v-if="usePsw" @click="changeLoginWay('noPsw')">免密登录</span>
                <span v-if="usePsw" @click="changeLoginWay('forgetPsw')">忘记密码？</span>
            </div>
          </div>
          <div style="margin-top:22px;">
              <div>
                <el-button v-if="!forgetPsw" style="width:100%;height: 40px;background:@mainColor" @click="loginEvent" type="primary">
                  <span>立即登录</span>  
                </el-button> 
                <el-button v-else style="width:100%;height: 40px;background:@mainColor" @click="verifiEvent" type="primary">
                  <span>下一步</span>  
                </el-button> 
              </div>
              <div style="margin-top: 10px;" v-if="!forgetPsw">
                <!-- <el-button style="width:100%;" class="wechat-login"><a style="display:block;" :href="`https://open.weixin.qq.com/connect/qrconnect?appid=wx71377dd3000e28c3&redirect_uri=https://www.xiaobaogong.com/wechat2.html&response_type=code&scope=snsapi_login&state=${url}#wechat_redirect`">微信扫码登录</a></el-button> -->
                <el-button style="width:100%;height: 40px;" class="wechat-login" @click="showDialog('wechat')"><a style="display:block;" href="javascript:void(0);">微信扫码登录</a></el-button>
              </div>
          </div>
          <!-- <div class="form">
              <div v-if="!forgetPsw" style="text-align:right;cursor:pointer" @click="showDialog('register')">
                  <span>还没账号？</span>
                  <span style="color:#222">免费注册</span>
              </div>
              <div v-if="forgetPsw" style="text-align:right;cursor:pointer"  @click="changeLoginWay('psw')">
                  <span>已有账号？</span>
                  <span style="color:#222">立即登录</span>
              </div>
          </div> -->
       </div>
    </el-dialog>
    

    <!-- 手机号注册 -->
    <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="showRegister" title="手机号注册" @close="closeDialog" :close-on-click-modal="false">
       <div>
          <div class="form">
              <el-input v-model="model.tel" type="text" placeholder="手机号"></el-input>
          </div>
          <div class="form">
              <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
              <a class="send-number" @click="regEvent" :disabled="disabled">{{sendWord}}</a>
          </div>
          <div class="form">
              <span>注册即代表同意<span style="color:#4A90E2;cursor:pointer" @click="agreement=true">《用户注册协议》</span>和<span style="color:#4A90E2;cursor:pointer" @click="privacy=true">《隐私政策》</span></span>
          </div>
          <div style="margin-top:22px;">
              <div>
                <el-button style="width:100%;background:@mainColor" @click="verifiEvent" type="primary">下一步</el-button> 
              </div>
          </div>
       </div>
     </el-dialog>
    

    <!-- 绑定手机号 -->
      <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="showSetTel" title="绑定手机号" @close="closeDialog" :close-on-click-modal="false">
       <div>
          <div class="form" style="margin-top: 20px;">
              <el-input v-model="model.tel" type="text" placeholder="手机号"></el-input>
          </div>
          <div class="form" style="margin-top: 20px;">
              <el-input v-model="model.verificode" type="text" placeholder="验证码"></el-input>
              <a class="send-number" @click="sendCode" :disabled="disabled">{{sendWord}}</a>
          </div>
         
          <div style="margin-top:45px;">
              <div>
                <el-button style="width:100%;background:@mainColor;height:40px;font-size:16px;" @click="bindingEvent" type="primary">立即登录</el-button> 
              </div>
          </div>

          <div class="form" style="margin-top: 80px;text-align:center;">
            <span class="form-span-desc">登录即代表同意<span style="color:#4A90E2;cursor:pointer" @click="agreement=true">《用户注册协议》</span>和<span style="color:#4A90E2;cursor:pointer" @click="privacy=true">《隐私政策》</span></span>

          </div>
       </div>
     </el-dialog>

     <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="showSetPsw" title="设置登录密码" @close="closeDialog" :close-on-click-modal="false">
       <div>
          <p style="margin:20px 0">密码设置8位以上且包含大小写字母、数字组合</p>
          <div class="form">
              <el-input v-model="model.password" type="password" placeholder="设置密码"></el-input>
          </div>
          <div class="form">
              <el-input v-model="model.confirmPsw" type="password" placeholder="确认密码"></el-input>
          </div>
          <div style="margin-top:22px;">
              <div>
                <el-button style="width:100%;" @click="finishedSetPsw" type="primary">完成</el-button> 
              </div>
              <p class="word-normal" v-if="showLater" @click="showSetPsw = false" style="color:#666;text-align:center;margin-top:20px;">跳过，稍候在个人中心设置</p>
          </div>
       </div>
     </el-dialog>

    <el-dialog width="360px" custom-class="memberDialog local-login pswSucDialog" :visible.sync="setPswSuccess" @close="closeDialog" :close-on-click-modal="false">
       <div style="text-align:center">
         <div class="psw-success">
           <img src="../assets/success.png" alt="">
         </div>
         <p class="word-big" style="margin: 15px 0;color:#222">密码设置成功</p>
         <div style="margin-top:22px;">
            <div>
              <el-button style="width:100%;" v-if="currentShowType !='register'" @click="changeLoginWay('psw')" type="primary">立即进入</el-button>
              <el-button style="width:100%;" v-else @click="getUserInfo" type="primary">立即进入</el-button>
            </div>
         </div>
       </div>
    </el-dialog>

    <!-- 微信安全登录 -->
    <el-dialog width="360px" custom-class="memberDialog local-login" :visible.sync="showWechatLogin" @close="closeDialog" :close-on-click-modal="false">
      <div style="text-align:center;margin-top: 10px;">
          <p class="wxcode-title">
            <img class="wxcode-title-img" src="@/assets/wechat.png" alt="">
            <span v-if="wxLoginFlag">微信{{currentShowType == 'register' ? '注册' : '安全登录'}}</span>
            <span v-else>微信绑定</span>
          </p>
          <div class="wechatcode">
              <img class="wechatcode-img" :src="wxCodeImg" alt="">
              <div class="wechatcode-desc" v-show="wxCodeMarkFlag" @click="getWxLoginqrCode">
                <div class="wechatcode-desc-wrap">
                  <p class="wechatcode-desc-img"><img src="@/assets/change.png" /></p>
                  <p class="wechatcode-desc-txt">点击刷新二维码</p>
                </div>
              </div>
          </div>
        <div class="wxcode-scan" v-if="wxLoginFlag">微信扫描二维码{{currentShowType == 'register' ? '注册' : '登录'}}</div>
        <div class="wxcode-scan" v-else>
            <p>尊敬的用户，用于系统升级，未绑定微信的</p>
            <p>手机账号需微信才能使用小包公</p>
        </div>
         <div class="word-middle wxcode-btnwrap" v-if="wxLoginFlag">
            <el-button v-show="wxcodeBtnFlag" class="wxcode-btn" @click="showDialog('login')">账号密码{{currentShowType == 'register' ? '注册' : '登录'}}</el-button>
         </div>
         <!-- <div class="word-smaller problem"><span>扫描{{currentShowType == 'register' ? '注册' : '登录'}}遇到问题？</span><a style="color:#4A90E2;" href="">点击这里</a></div> -->
          <div class="form">
            <span class="form-span-desc" v-if="wxLoginFlag">{{currentShowType == 'register' ? '注册' : '登录'}}即代表同意<span style="color:#4A90E2;cursor:pointer" @click="agreement=true">《用户注册协议》</span>和<span style="color:#4A90E2;cursor:pointer" @click="privacy=true">《隐私政策》</span></span>
            <span class="form-span-scan" v-else>请使用微信扫描二维码绑定</span>
          </div>
      </div>
    </el-dialog>

    <el-dialog width="900px" custom-class="memberDialog word-dialog" :visible.sync="agreement" top="100px">
       <div class="agreement-body">
        <h4>“小包公”用户注册服务协议</h4>
        <span>本协议是广东博维创远科技有限公司（以下简称“公司”）与您（以下称“用户”）在协商一致的基础上，就“小包公”法律AI平台（以下简称“小包公”）服务所订立的有效合约。</span>
        <p>一、注册账户  </p>
        <div>
          <span>（一）用户在“小包公”点击“注册”按钮，即视为用户已阅读、理解本协议所有条款以及“小包公”所包含的各项指引、规则、政策、法律声明，并同意受其约束；且视为用户确认自己具有享受“小包公”服务、进行消费、签署合同等相应的权利能力和行为能力，以及能够独立承担法律责任。</span>
        </div>
        <div><span>（二）用户注册成功后，即生成专属账号和密码等账户信息。一个用户只能注册一个账户。</span></div>
        <div><span>（三）用户注册的账号归“小包公”所有，用户只有使用权。“小包公”享有在中华人民共和国大陆地区施行之法律允许的范围内独自决定提供或拒绝服务、关闭或注销用户账号、编辑或清除内容、取消订单的权利。</span></div>
        <div><span>（四）用户在注册时应提供完整、详尽、真实的个人资料，若所提供的资料日后有变更，用户应及时登录账号进行更新。若用户在“小包公”留下的个人资料与事实不符的，“小包公”有权停止向其继续提供产品和服务。当用户向“小包公”主张其拥有某账号时，若该账号在“小包公”的身份信息记录与用户的身份信息有任何不符，“小包公”有权不予认定该账号为用户所有。</span></div>
        <p>二、授权使用及限制</p>
        <div><span>（一）授权使用</span></div>
        <div style="padding-left:14px;"><span>公司在服务期限内授权用户按照本协议约定的方式使用“小包公”服务。“小包公”及其所含资料（包括文件、数据、案例等）仅限于用户以参考为目的使用（统称为“授权使用”）。</span></div>
        <div><span>（二）授权限制：</span></div>
        <div style="padding-left:14px;"><span>用户经授权使用“小包公”及其所含资料时，应遵守以下规则：</span></div>
        <div style="padding-left:14px;"><span>  1.不得对“小包公”全部或部分资料进行再发行、转发、出版、转让、商业或其他开发。</span></div>
        <div style="padding-left:14px;"><span>  2.不得通过对“小包公”资料系统提取或分析而直接或间接创建或编纂任何产品或作品，包括但不限于专辑、汇编、数据库、目录、期刊。 </span></div>
        <div style="padding-left:14px;"><span>  3.不得向他人转让或与他人共用、分享所注册的“小包公”账户。</span></div>
        <div style="padding-left:14px;"><span>  4.不得利用“小包公”从事违法犯罪、违背公序良俗的活动。</span></div>
        <p>三、服务费用和服务期限</p>
        <div><span>“小包公”注册不收取服务费用，部分功能的服务费用和服务期限将在订购协议或订购的系统页面上予以列明，用户可自行选择服务类型并按列明的价格进行支付。</span></div>

        <p>四、双方的权利、义务</p>
        <div><span>（一）与“小包公”产品及其衍生品相关的所有资料及源代码以及“小包公”向用户提供的任何内容、技术或技术支持、软件、服务等的知识产权均属于公司所有，用户无权复制、传播、转让、许可或提供他人使用。</span></div>
        <div><span>（二）“小包公”所使用和显示的商标、服务标识、商品名称和标志均属于公司所有，用户不得进行复制、仿造或使用。</span></div>
        <div><span>（三）“小包公”有权随时对软件及数据库的功能、结构和内容进行添加或者删改，无需事先通知用户。</span></div>
        <div><span>（四）“小包公”有权删除各类不符合法律、政策或虚假的信息内容，无需事先通知用户。</span></div>
        <div><span>（五）“小包公”有权通过邮件、短信、电话等形式，向在“小包公”注册、购买产品或服务的用户发送订单和促销信息。</span></div>
        <div><span>（六）公司应在现有技术上维护平台服务的正常进行，并努力提升和改进技术，为用户提供优质高效的服务。</span></div>
        <div><span>（七）在未经“小包公”明示许可的情况下，用户不得将账号信息或访问账号的其他方式提供给任何未经“小包公”授权的单位或个人。同时，用户应对所有使用本人账号信息对“小包公”的访问负责。如果用户的账号已经泄漏、丢失或被盗，或者用户认为有泄露、丢失和被盗的风险，用户应当马上联系“小包公”的工作人员进行处理。</span></div>
        <div><span>（八）未经“小包公”书面授权，用户不得建立“小包公”网站的镜像（包括全部和局部镜像）。</span></div>
        <div><span>（九）用户应当遵守宪法和法律，履行下列义务：</span></div>
        <div style="padding-left:14px;"><span>  1.不得发表或散布：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权、推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。</span></div>
        <div style="padding-left:14px;"><span>  2.不得利用“小包公”从事洗钱、窃取商业秘密或个人信息等违法犯罪活动。</span></div>
        <div style="padding-left:14px;"><span>  3.不得干扰“小包公”的正常运营，侵入“小包公”及国家计算机信息系统。</span></div>
        <div style="padding-left:14px;"><span>  4.不得利用在“小包公”注册的账户进行牟利性经营活动。</span></div>
        <div style="padding-left:14px;"><span>  5.不得侵犯他人著作权、商标权等知识产权或其他合法权益。</span></div>
        <div style="padding-left:14px;"><span>  6.不得教唆他人从事前述所禁止的行为。</span></div>
        <div style="padding-left:14px;"><span>  用户未履行上述义务的，“小包公”有权作出独立判断并采取暂停或关闭用户帐号等措施。</span></div>
        <div><span>（十）用户不得以任何目的在“小包公”平台使用网络爬虫或其他自动下载程序或设备，包括但不限于从“小包公”获取未公开的数据、他人邮寄或邮件地址、发布商业广告。</span></div>

        <p>五、免责声明</p>
        <div><span>（一）“小包公”出具的报告、意见或解答，系根据法律法规、大数据分析得出，仅供用户参考，不代表司法机关的观点、结论，公司亦不承担任何责任。</span></div>
        <div><span>（二）“小包公”可能包含指向其他网站或资源的链接，用户通过这些链接获得的任何第三方资料或资源以及与第三方发生的交易均与“小包公”无关，公司不承担任何责任。</span></div>
        <div><span>（三）用户因访问、浏览“小包公”并下载有关资料而导致电脑系统的任何损毁或数据损失均与“小包公”无关，公司不承担任何责任。</span></div>
        <div><span>（四）用户使用“小包公”为任何第三方提供服务的，对于用户和第三方之间的纠纷，“小包公”不承担任何责任。 </span></div>
        <div><span>（五）“小包公”仅作为第三方平台为律师或其他用户提供技术帮助，公司对于用户采购的具体法律服务不作任何承诺，也不承担任何责任。 </span></div>
        <div><span>（六）“小包公”所提供的搜索结果因数据更新、技术进步等原因可能存在滞后、模糊、不准确、中断等情况，公司对此不承担任何责任。</span></div>

        <p>六、信息安全及保密</p>
        <div><span>（一）对于用户在注册、购买过程中提供、上传或使用的真实姓名/名称、通信地址、联系电话、电子邮箱等个人信息、相关数据或其他商业秘密，“小包公”应予严格保密。</span></div>
        <div><span>（二）用户应谨慎合理地保存、使用其账号和密码。“小包公”将凭密码进行的所有活动视为用户的行为。</span></div>
        <div><span>（三）用户不得将在“小包公”注册获得的账户借给他人使用，否则应承担由此产生的全部责任，并与实际使用人承担连带责任。</span></div>

        <p>七、违约责任</p>
        <div><span>（一）“小包公”未履行本协议约定的保密义务而给用户造成损失的，应当承担损害赔偿责任。</span></div>
        <div><span>（二）用户未履行本协议约定的义务而给“小包公”或第三人造成损失的，应当承担损害赔偿责任。</span></div>

        <p>八、争议解决</p>
        <div><span>（一）凡因本协议而产生的争议，双方应友好协商解决。协商解决不成的，双方均同意将争议提交中国广州仲裁委员会仲裁解决。 </span></div>
        <div><span>（二）双方将以下手机号码或E-mail作为仲裁案件及接收另一方通知的电子送达地址： </span></div>
        <div style="padding-left:14px;"><span>  公司的联系方式：以工商登记信息为准。</span></div>
        <div style="padding-left:14px;"><span>  用户的联系方式：以用户在“小包公”绑定的信息为准。</span></div>


        <p>九、送达</p>
        <div><span>本协议项下所有的通知均可通过“小包公”平台重要页面公告、电子邮件等方式发送。该等通知于发送之日视为已送达收件人。</span></div>

        <p>十、其他</p>
        <div><span>（一）本协议自用户注册之时起生效。</span></div>
        <div><span>（二）根据国家法律法规变化及网络运营需要，“小包公”可在不事先通知用户的情况下，修改本协议下的条款和条件或单独条款和条件。一旦“小包公”将这些修改后的条款和条件或单独条款和条件登载公示在“小包公”上即生效，并代替原来的协议。用户如继续使用本服务，则应被视为对修改后的条款和条件或单独条款和条件给予有效而不可撤销的同意。用户在使用本服务时，应定期查阅这些条款和条件。</span></div>
        <div><span>（三）本协议中的任一条款无论因何种原因全部或部分无效，其余的条款仍然有效并对双方具有约束力</span></div>

      </div>
     </el-dialog>

     <el-dialog width="900px" custom-class="memberDialog word-dialog" :visible.sync="privacy" top="100px">
       <div class="agreement-body">
         <h4>隐私政策</h4>
         <div>
           <span>（一）除司法机关或其他有权机关依法要求提交个人资料外，未经用户的同意，“小包公”不会擅自披露或改变用户的个人信息及使用方式。</span>
         </div>
        <div><span>（二）“小包公”尊重并致力于保护用户的隐私权，但在“小包公”注册或使用某些服务时，用户需提交个人身份验证信息（包括但不限于您的姓名、地址、职业、电子邮件地址、电话号码等），以便于我们核实您是否有资格使用“小包公”所提供的某些信息、资料或服务，以及能更好的提供客户服务和技术支持，包括促进您与其他用户和客户之间的关系，用户有权自行选择是否提交及公开相应信息，但如果不提交或公开相关信息，可能导致在使用某些信息、资料或服务时受到一定限制，此外用户通过本网站及软件完成请求服务或交易必需的情形下，应允许我们向正当第三方提供适当合理的信息。 </span></div>
        <div><span>（三）用户浏览使用“小包公”及相关服务时，某些信息包括但不限于IP地址、访问日期、页面等，可能会通过互联网协议地址、cookies、网址标签以及导航数据采集等各种技术和方法被采集。“小包公”将主要基于改善本网站内容、更好的提供订制化或其他服务、更有效信息交流以及其他本隐私政策所列明的目的合理使用相关信息。</span></div>
        <div><span>（四）在以下情形，可能根据国家相关规定披露您的信息：</span></div>
        <div style="padding-left:14px;"><span>1、您的行为违反了互联网相关法律法规的规定，或可能损害或妨碍其他用户的权益时，披露您的个人信息是为了辨识、联络或采取法律行动所必需时；</span></div>
        <div style="padding-left:14px;"><span>2、按法律规定或涉及司法或政府的调查而披露；</span></div>
        <div style="padding-left:14px;"><span>3、法律法规所规定的其他必须披露个人信息的情形。</span></div>
            

       </div>
     </el-dialog>

     <vipPane v-if="vipPaneShow" :show.sync="vipPaneShow" vipType="law" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import QRCode from "qrcodejs2";
import vipPane from '@/components/vipPane';
import loadFailImg from '@/assets/white.png'
import { services } from '@/service';
// import layoutMenu from '@/components/layoutMenu';
import { projectInfoConfig } from '@/constant';
import defaultAvatar1 from '@/assets/default-icon.png';
import defaultAvatar2 from '@/assets/default-avatar.png';

export default {
  data() {
    return {
      projectInfoConfig,
      defaultAvatar1,
      defaultAvatar2,
      model: {
        tel: "",
        name: "",
        password: "",
        verificode: "",
        confirmPsw: "",
      },
      wxCodeImg: loadFailImg,
      url: "",
      privacy: false,
      agreement: false,
      showRegister: false,
      showSetTel: false,
      wxLoginFlag: true,
      showLogin: false,
      showSetPsw: false,
      forgetPsw: false,
      setPswSuccess: false,
      showLater: false,
      usePsw: true,
      telChcked: false,
      showWechatLogin: false,
      wxcodeBtnFlag: true,
      version: window.version,
      userInfo: {},
      noPassword: false,
      remember: true,
      secretKey: "",
      sendWord: "发送验证码",
      disabled: false,
      productList: [],
      activeBuy: "",
      productModel: {},
      activeWay: "",
      way: {},
      orderId: "",
      payTimeOut: "",
      loginQrcodeKey: "",

      wxCodeMarkFlag: false,
      currentShowType: 'login',
      currentSetPswType: 'register',
      loginGdStatus: false,
      vipPaneShow: false
    };
  },
  created() {
    if (this.version === 'guangdianzhongda') {
      this.getUserInfo();
    }
  },
  components: { vipPane },
  computed: {
    ...mapGetters(["perssion", "freeTime", "buyVip", "loginStatus", 'isEnterprise', 'lawIsExpired', 'lawFreeSurplus', 'lawInfo', 'isThird']),
    titleWord: function() {
      if (this.noPassword) {
        return "免密登录";
      } else if (this.forgetPsw) {
        return "验证手机号";
      } else {
        return "账号密码登录";
      }
    },
  },
  watch: {
    remember: function(val) {
      if (!val) {
        localStorage.removeItem("loginInfo");
      }
    },
    buyVip: function(val) {
      if (!val && this.payTimeOut) {
        clearInterval(this.payTimeOut);
      }
      if (val) {
        this.choiceWay(this.productModel.subItem[0], 0);
      }
    },
  },

  mounted() {
    // this.$store.state.loading = false
    this.url = window.btoa(
      location.href.slice(0, location.href.indexOf("/index.html"))
    );
    this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    var that = this;
    document.onkeydown = function(e) {
      e = window.event || e;
      if (that.loginStatus && (e.code == "Enter" || e.code == "enter")) {
        //验证在登录界面和按得键是回车键enter
        that.loginEvent(); //登录函数
      }
    };

    if (this.$route.query.wechat && !this.userInfo.tel) {
      this.showSetTel = true;
    } else if (this.userInfo.tel) {
      sessionStorage.removeItem("productList");
      this.httpGet("user/products?purpose=PC").then((data) => {
        if (data && data.statusCode == 1) {
          // this.productList = data.data;
          data.data.forEach((v) => {
            var find = _.find(this.productList, { name: v.name });
            if (!find) {
              v.subItem = [];
              v.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                payPrince: v.payPrince,
                productList: v.productList,
                discountPrince: v.discountPrince,
                firstPrince: v.firstPrince,
                userType: v.userType,
              });
              this.productList.push(v);
            } else {
              find.subItem.push({
                id: v.id,
                name: v.name,
                desc: v.desc,
                descHtml: v.descHtml,
                chargeCycle: v.chargeCycle,
                chargeType: v.chargeType,
                productList: v.productList,
                payPrince: v.payPrince,
                discountPrince: v.discountPrince,
                firstPrince: v.firstPrince,
                userType: v.userType,
              });
            }
          });
          if (data.data.length > 0) {
            this.activeBuy = data.data[0].name;
            this.productModel = data.data[0];
          }
          sessionStorage.setItem(
            "productList",
            JSON.stringify(this.productList)
          );
        }
      });
    }
  },

  methods: {
    // 点击完成设置密码
    finishedSetPsw() {
      console.log(this.currentShowType)
      this.setPassword()
    },
    // 获取微信登录 qrCode
    getWxLoginqrCode() {
      this.httpPost(`wechat/qrCode`).then((data) => {
        if (data && data.statusCode == 1) {
          
          this.wxCodeMarkFlag = false;
          this.loginQrcodeKey = data.data.key;
          let ticket = data.data.ticket;

          this.getWxLoginCode(ticket)
          
        }
      });
    },
    // 生成微信登录二维码
    getWxLoginCode(ticket) {
      if (!ticket) return;

      this.wxCodeImg = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`;

      let key = 0;
      let timer = setInterval(() => {
        this.checkWxLoginCode(timer, key++)
      }, 2000)

    },
    // 验证微信登录二维码
    checkWxLoginCode(timer, key) {
      if (!this.showWechatLogin) {
        clearInterval(timer);
      }

      // console.log(timer, key)
      this.httpGet("wechat/official/login?key="+this.loginQrcodeKey).then((data) => {
        // console.log(data)
        if (data && data.statusCode == 1) {

          if (data.data.is_login == '0') {
            clearInterval(timer);
          } else if (data.data.is_login == '2') {
            clearInterval(timer);
            window.localStorage.setItem("token", data.data.token);
            sessionStorage.setItem("_TOKEN_", data.data.token);
            this.showDialog();
            this.getUserInfo();
            this.$store.commit("setLocalLogin", false);
            
          }
          
        } else {
          clearInterval(timer);
        }
      });

      // 超过一分钟为验证成功，重新生成二维码
      if (key >= 30) {
        clearInterval(timer);

        this.wxCodeMarkFlag = true;
      }
    },
    // 电话验证
    telInputBlur() {
      let tel = this.model.tel;
      let telExg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (tel) {
        if (telExg.test(tel)) {
          this.telChcked = false;
        } else {
          this.telChcked = true;
        }
      }
    },
    goStaticHome() {
      if (this.isThird) {
        return;
      }
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) +
        "/index.html";
    },
    goAbout() {
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) +
        "/about.html";
    },
    goNews() {
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) +
        "/news.html";
    },
    goStaticPage(type) {
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) +
        `/${type}.html`;
    },
    goLawData() {
      var token = localStorage.getItem("token");
      var userInfo = localStorage.getItem("userInfo");
      token && sessionStorage.setItem("_TOKEN_", token);
      userInfo && sessionStorage.setItem("_USER_INFO_", userInfo);
      var locationHref = window.location.href;
      location.href =
        locationHref.slice(0, locationHref.indexOf("/home.html")) + "/lawdata/";
    },
    openBuyVip() {
      if (this.productModel.subItem && this.productModel.subItem.length > 0) {
        //  this.choiceWay(this.productModel.subItem[0],0);
        this.$store.commit("setBuyVip", true);
      } else {
        this.$message({
          message: "获取产品失败，请稍后再试",
          type: "warning",
        });
      }
    },
    changeActive($event) {
      if (this.$route.path == "/main/home") {
        $event.currentTarget.className = "main-header white-header";
      }
    },
    removeActive($event) {
      if (this.$route.path == "/main/home") {
        $event.currentTarget.className = "main-header black-header";
      }
    },
    changeLoginWay(type) {
      this.noPassword = false;
      this.forgetPsw = false;
      this.usePsw = false;
      if (type == "psw") {
        this.usePsw = true;
      } else if (type == "noPsw") {
        this.noPassword = true;
      } else {
        this.forgetPsw = true;
      }
    },
    sendCode() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (this.sendWord !== "重新发送" && this.sendWord !== "发送验证码") {
        return;
      }

      var time = 60;
      var timer = setInterval(() => {
        time--;
        this.sendWord = `${time}s`;
        if (time == 0) {
          clearInterval(timer);
          this.sendWord = "重新发送";
          this.disabled = false;
        }
      }, 1000);

      this.disabled = true;

      this.httpPost("user/sms/send", { tel: this.model.tel }).then((data) => {
        if (data && data.statusCode == 1) {
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    qrcode(name, id, discountPrince) {
      this.httpPost("wechat/order", {
        productId: id,
        price: discountPrince,
        body: "小包公-" + name,
      }).then((data) => {
        if (data && data.statusCode == 1) {
          let qrcode = new QRCode("qrcode", {
            width: 130, // 二维码宽度，单位像素
            height: 130, // 二维码高度，单位像素
            text: data.data.codeUrl, // 生成二维码的链接
          });
          this.orderId = data.data.orderId;
          clearInterval(this.payTimeOut);
          this.payTimeOut = setInterval(() => {
            this.getOrderStatus();
          }, 2000);
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    getOrderStatus() {
      this.httpGet(`wechat/order/${this.orderId}`).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.status == "SUCCESS") {
            clearInterval(this.payTimeOut);
            this.$message({
              message: "支付成功",
              type: "success",
            });
            this.$store.commit("setBuyVip", false);
            this.$router.go(0);
          }
        }
      });
    },
    showDialog(type, mold) {
      this.showRegister = false;
      this.$store.commit("setLocalLogin", false);
      this.showLater = false;
      this.showSetPsw = false;
      this.setPswSuccess = false;
      this.showWechatLogin = false;
      this.wxcodeBtnFlag = true; // 微信扫码 - 是否显示“账号密码登录”按钮
      this.wxLoginFlag = true; // 微信扫码 - true:登录；false:绑定
      this.wxCodeMarkFlag = false;
      
      if (type == "register") {
        this.showRegister = true;
      }
      
      if (type == "login") {
        this.$store.commit("setLocalLogin", true);
        this.usePsw = true;
        this.noPassword = false;
        this.forgetPsw = false;

        this.currentSetPswType = 'login'
      }
      if (mold) {
        switch (mold) {
          case 'register':
            this.wxcodeBtnFlag = false;
            this.currentShowType = 'register'
            this.currentSetPswType = 'register'
            break;
          case 'bind':
            this.wxLoginFlag = false;
            break;
          case 'login':
            this.currentShowType = 'login'
            this.currentSetPswType = 'login'
            break;
        }
      }
      if (type == "wechat") {
        this.showWechatLogin = true;
        this.getWxLoginqrCode();

        this.currentSetPswType = 'register'
      }

      console.log(this.currentSetPswType)
    },
    verifiEvent() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.model.verificode) {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      if (this.model.verificode.length > 6) {
        this.$message({
          message: "请输入正确的验证码",
          type: "warning",
        });
        return;
      }
      this.httpPost("user/valid", {
        tel: this.model.tel,
        code: this.model.verificode,
      }).then((data) => {

        console.log(data)
        if (data && data.statusCode == 1) {
          if (data.data.token) {
            window.localStorage.setItem("token", data.data.token);
            sessionStorage.setItem("_TOKEN_", data.data.token);
            this.model.password = "";
            this.showRegister = false;
            this.showSetPsw = false;
            this.setPswSuccess = false;
            if (!this.noPassword && this.currentShowType != 'register' && this.version != 'guangdianzhongda') {
              this.showSetPsw = true;
            } else {
              this.loginStatus = false;
              this.showWechatLogin = false;
              this.getUserInfo();
            }
          } else {
            this.$message({
              message: data.data.msg,
              type: "warning",
            });
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    regEvent() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (this.sendWord !== "重新发送" && this.sendWord !== "发送验证码") {
        return;
      }

      this.httpPost("user/reg", { tel: this.model.tel }).then((data) => {
        if (data && data.statusCode == 1) {
          var time = 60;
          var timer = setInterval(() => {
            time--;
            this.sendWord = `${time}s`;
            if (time == 0) {
              clearInterval(timer);
              this.sendWord = "重新发送";
              this.disabled = false;
            }
          }, 1000);

          this.disabled = true;
          this.$message({
            message: "发送成功",
            type: "success",
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    bindingEvent() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return;
      }
      if (!this.model.verificode) {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      if (this.model.verificode.length > 6) {
        this.$message({
          message: "请输入正确的验证码",
          type: "warning",
        });
        return;
      }
      this.httpPost("user/valid", {
        tel: this.model.tel,
        code: this.model.verificode,
      }).then((data) => {
        if (data && data.statusCode == 1) {
          if (data.data.token) {
            window.localStorage.setItem("token", data.data.token);
            sessionStorage.setItem("_TOKEN_", data.data.token);
            this.model.password = "";
            this.showRegister = false;
            this.showSetTel = false;
            this.showSetPsw = false;
            // this.showSetPsw = true;
            // this.showLater = true;
            this.getUserInfo();
          } else {
            this.$message({
              message: data.data.msg,
              type: "warning",
            });
          }
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    choicePro(item) {
      this.productModel = item;
      this.activeBuy = item.name;
      this.choiceWay(this.productModel.subItem[0], 0);
    },
    choiceWay(col, index) {
      this.activeWay = index;
      this.way = col;
      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        this.qrcode(col.name, col.id, col.discountPrince);
      });
    },
    setPassword() {
      if (!this.model.password) {
        this.$message({
          message: "请输入密码",
          type: "warning",
        });
        return;
      }

      if (this.model.password !== this.model.confirmPsw) {
        this.$message({
          message: "两次输入的密码不一致",
          type: "warning",
        });
        return;
      }

      this.httpPost(`user/password`, { password: this.model.password }).then(
        (res) => {
          if (res && res.statusCode == 1 && res.data.code == 1) {
            this.showSetPsw = false;
            this.$message({
              message: "设置成功",
              type: "success",
            });
            
            // console.log(this.currentSetPswType)
            if (this.currentSetPswType == 'register') {
              this.showDialog();
              this.getUserInfo()
            } else {
              if (this.currentShowType == 'register') {
                this.showDialog();
                this.getUserInfo()
              } else {
                this.showDialog('login');
              }
            }

            
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
            
            if (res.statusCode == 201) {
              this.showDialog('wechat', 'bind')
            }
          }
        }
      );
    },
    activationEvent() {
      let param = {
        secretKey: this.secretKey,
      };
      this.httpPost("admin/period", param).then((data) => {
        if (data && data.statusCode == 1) {
          this.$store.commit("setFreeTime", false);
          this.$message({
            message: "激活成功",
            type: "success",
          });
          var that = this;
          setTimeout(() => {
            that.$router.go(0);
          }, 1000);
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    goTarget(type) {
      let token = window.localStorage.getItem("token");
      if (!token) {
        this.$message({
          message: "您尚未登录，请先登录再进行操作",
          type: "warning",
        });
        return;
      }

      if (type == "law") {
        let { href } = this.$router.resolve({
          path: "/law/home",
        });
        window.sessionStorage.removeItem("historyList");
        window.open(href, "_blank");
      } else {
        let { href } = this.$router.resolve({
          path: "/case/search",
        });
        window.open(href, "_blank");
      }
    },
    loginOut() {
      this.httpGet("admin/logout").then((data) => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("_TOKEN_");
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        sessionStorage.removeItem("userInfo");
        this.userInfo = {};
        this.goStaticHome();
      });
    },
    closeDialog() {
      this.$store.commit("setBuyVip", false);
    },
    openLocalLogin() {
      this.$store.commit("setLocalLogin", true);
    },
    closeLocalLogin() {
      this.$store.commit("setLocalLogin", false);
    },
    getUserInfo() {
      this.httpGet(`admin/user`).then((res) => {
        if (res && res.statusCode == 1) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          sessionStorage.setItem("_USER_INFO_", JSON.stringify(res.data));
          this.userInfo = res.data;
          
          // this.$message({
          //   message: "登录成功",
          //   type: "success",
          // });
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });

          if (res.statusCode == 201) {
            this.showDialog('wechat', 'bind')
          } else if (res.statusCode == 202) {
            this.showDialog()
            this.showSetTel = true;
          }
        }
      });
    },
    loginEvent() {
      if (!this.model.tel) {
        this.$message({
          message: "请输入手机号或邮箱",
          type: "warning",
        });
        return;
      }

      if (this.noPassword) {
        this.verifiEvent();
      } else {
        if (!this.model.password) {
          this.$message({
            message: "请输入密码",
            type: "warning",
          });
          return;
        }

        this.httpPost(`user/login`, {
          tel: this.model.tel,
          password: this.model.password,
        }).then((data) => {

          console.log(data)
          // return false;
          if (data && data.statusCode == 1) {
            if (data.data.token) {
              window.localStorage.setItem("token", data.data.token);
              sessionStorage.setItem("_TOKEN_", data.data.token);
              this.getUserInfo();
              this.$store.commit("setLocalLogin", false);
            } else {
              this.$message({
                message: data.data.msg,
                type: "warning",
              });
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
      }
    },
    goBack() {
      if (this.$refs["home"].goback) {
        this.$refs["home"].goback();
      } else if (this.$route.path.indexOf("step") !== -1) {
        if (this.$route.query.home || window.version == "procuratorate") {
          this.$router.push({
            path: "/forecast/home",
            bookId: sessionStorage.getItem("bookId"),
            city: this.$route.query.city || sessionStorage.getItem("city"),
          });
        } else {
          this.$router.push({
            path: "/forecast/dashboard",
          });
        }
      } else if (this.$route.path.indexOf("home") !== -1) {
        this.$router.push({
          path: "/forecast/dashboard",
        });
      } else {
        this.$router.go(-1);
      }
    },
    goCenter() {
      this.$router.push({
        path: "/forecast/center",
      });
    },
  },
  destroyed() {
    if (this.payTimeOut) {
      clearInterval(this.payTimeOut);
    }
  },
};
</script>
<style scoped lang="less">
.top-contrainer {
  position: relative;

  .layout-header {
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .layout-header-user-info {
      display: flex;
      align-items: center;

      .system-expired-info {
        margin-right: 30px;

        .vip-time-info {
          display: flex;
          align-items: center;
          height: 24px;

          .vip-time-info-content {
            color: #FEDDA9;
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            background: linear-gradient(270deg, #383E49 0%, #505868 100%);
            border-radius: 2px 0px 0px 2px;
            padding: 0 10px;

            .vip-time-info-img {
              width: 22px;
            }
          }
          .vip-time-info-renew-btn {
            color: #172237;
            font-size: 12px;
            line-height: 24px;
            background: #FEDDA9;
            border-radius: 0px 2px 2px 0px;
            padding: 0 10px;
            cursor: pointer;
          }
        }
        
        .vip-free-surplus {
          display: flex;
          align-items: center;
          color: #4E555B;
          font-size: 14px;
          line-height: 20px;

          .el-icon-question {
            position: relative;
            top: -1px;
            font-size: 16px;
            color: #E6A23C;
            cursor: pointer;
            margin-right: 2px;
          }

          .vip-free-surplus-btn {
            color: #172237;
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            margin-left: 10px;
            background-color: #FEDDA9;
            border-radius: 2px;
            padding: 0 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.layout-header-system {
  display: flex;
  align-items: center;
  margin: 0 50px 0 10px;

  .layout-header-system-logo {
    height: 24px;
    cursor: pointer;
    margin-right: 10px;
  }
  .layout-header-system-label {
    color: #172237;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }
  .layout-header-system-enterprise {
    color: #3F6EFC;
    font-size: 14px;
    line-height: 20px;
    border: 1px solid #3F6EFC;
    border-radius: 8px 0 8px 0;
    padding: 0 10px;
    margin-left: 10px;
  }
}
.header-portrait {
  display: flex;
  .pic {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 10px;
    background-color: #f2f2f2;
    display: inline-block;
  }
  .tel {
    color: #fff;
  }
}

.form {
  margin-top: 14px;
  position: relative;
  .password {
    display: flex;
    justify-content: space-between;
    span {
      color: @wordColor1;
      cursor: pointer;
    }
  }
  .send-number {
    position: absolute;
    display: inline-block;
    right: 10px;
    color: @mainColor;
    top: 14px;
    cursor: pointer;
  }
}
.problem {
  margin: 10px 0 20px 0;
}

.form p {
  color: rgba(92, 121, 176, 1);
  padding-bottom: 6px;
}
.psw-success {
  margin: 30px auto;
  width: 64px;
  img {
    width: 100%;
  }
}
</style>

<style lang="less">
.wxcode-scan {
  color:#222;
  font-size:14px;
  width: 266px;
  margin: 0 auto;
  line-height: 20px;
}
.form-phone {
  color: #E42626;
  font-size: 14px;
  margin-top: 6px;
}
.wxcode-title {
    color: #222;
    font-size: 18px;
    margin-bottom: 5px;
    .wxcode-title-img {
        width: 32px;
        height:auto;
        vertical-align: middle;
        margin-right: 5px;
    }
}
.wxcode-btnwrap {
    margin: 22px auto 27px;
    text-align: center;
    .wxcode-btn {
        border:1px solid #ccc;
        color: #222;
        width: 140px;
        height: 40px;
        background: #fff;
        box-sizing: border-box;
        font-size: 16px;
        &:hover {
            border: 1px solid #E42626;
            color: #E42626;
        }
    }
}
.code-img {
    width: 50%;
    height: auto;
}
.form-span-desc {
    font-size: 12px;
}
.form-span-scan {
    font-size: 14px;
    color: #438FE8;
    margin-top: 40px;
    padding-bottom: 15px;
    display: block;
}
.wechat-login {
  border: 1px solid #ccc;
  background: #fff;
  color: rgba(228, 38, 38, 1);
  &:hover {
    background: #fff;
    border: 1px solid #E42626;
  }
  a {
    color: rgba(228, 38, 38, 1);
  }
}

.pswSucDialog .el-dialog__header {
  border-bottom: none !important;
}

.wechatcode {
  position: relative;
  margin: 20px 0;
  
}
.wechatcode .wechatcode-img {
  width: 50%;
  height: auto;
}

.wechatcode .wechatcode-desc {
  position: absolute;
  display: flex;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(255,255,255, .95);
  align-items: center;
  color: rgb(74, 144, 226);
  justify-content: center;
  cursor: pointer;
}

.wechatcode .wechatcode-desc .wechatcode-desc-txt {
  font-size: 12px;
  display: block;
  margin-top: 15px;
}

.wechatcode .wechatcode-desc-img img {
  width: 40px;
}


</style>



// WEBPACK FOOTER //
// src/views/Layout.vue